import styled from "styled-components";

const InputDiv = styled.div`
  border: none;
  border-radius: 3px;
  background-color: #fbfbfb;
  color: #6e6e6e;
  font-size: inherit;
  line-height: normal;
  transition: background-color 0.15s ease-out 0s;
`;

export default InputDiv;
